function parseFraction(str) {
    if (!str) return null;
    const trimmed = str.trim();
    const mixed = trimmed.match(/^(\d+)\s+(\d+)\/(\d+)$/);
    if (mixed) return parseInt(mixed[1]) + parseInt(mixed[2]) / parseInt(mixed[3]);
    const frac = trimmed.match(/^(\d+)\/(\d+)$/);
    if (frac) return parseInt(frac[1]) / parseInt(frac[2]);
    const num = parseFloat(trimmed);
    return isNaN(num) ? null : num;
}

function toFractionString(value) {
    const FRACTIONS = [
        [1, '1'], [3/4, '3/4'], [2/3, '2/3'], [1/2, '1/2'],
        [1/3, '1/3'], [1/4, '1/4'], [1/8, '1/8'],
    ];
    const whole = Math.floor(value);
    const remainder = value - whole;
    if (remainder < 0.05) return whole > 0 ? `${whole}` : '0';
    let closest = FRACTIONS[0];
    let minDiff = Math.abs(remainder - FRACTIONS[0][0]);
    for (const f of FRACTIONS) {
        const diff = Math.abs(remainder - f[0]);
        if (diff < minDiff) { minDiff = diff; closest = f; }
    }
    return whole > 0 ? `${whole} ${closest[1]}` : closest[1];
}

export function scaleQuantity(quantity, multiplier) {
    if (!quantity || multiplier === 1) return quantity;
    const num = parseFraction(quantity);
    if (num === null) return quantity;
    const scaled = num * multiplier;
    if (Math.abs(scaled - Math.round(scaled)) < 0.05) return `${Math.round(scaled)}`;
    return toFractionString(scaled);
}
